import { Outlet, createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$username/_profile/resources")({
  component: ResourcesLayout,
});

function ResourcesLayout() {
  return <Outlet />;
}
